import React, { useContext, useEffect, useState } from "react";
import "./styles.scss";
import { Image, message, Modal } from "antd";
import InputField from "../../NpComponents/InputField/InputField";
import { AuthContext } from "../../Context/AuthContext/AuthContext";
import { server } from "../../utils/fetch";
import { fetchFooterAbout, fetchFooterBooking } from "../../utils/api-calls/footerCalls";
const FooterBookingDetail = () => {
  let url = `${server}/footer-booking`;
  const { authUser, footerBooking, setFooterBooking } =
    useContext(AuthContext);
  const [dataValues, setDataValues] = useState({
    info: "",
    link: ""
  });

  useEffect(() => {
    if (footerBooking) {
      setDataValues({
        info: footerBooking.info,
        link: footerBooking.link
      });
    }
  }, [footerBooking]);

  const updateDatabase = async () => {
    try {
      const res = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataValues),
      });
      const data = await res.json();
      if (res.status == 200 || res.status == 201) {
        let footerAboutf = await fetchFooterBooking();
        setFooterBooking(footerAboutf);
        return message.success(data.message);
      }

      return message.error(data.message);
    } catch (error) {
      message.error(`Updating" Failed!`);
    }
  };
  return (
    <div className="admin-landing-hero">
      <div className="main-banner">
        <InputField
          inputValue={dataValues}
          setInputValue={setDataValues}
          name="info"
          type="text"
          placeholder="Enter Booking Info..."
          label="Booking Info"
        />

        <InputField
          inputValue={dataValues}
          setInputValue={setDataValues}
          name="link"
          type="text"
          placeholder="Enter Booking Link..."
          label="Booking.Com Link"
        />

        <button
          className="np-admin-main-button"
          onClick={() => {
            updateDatabase();
          }}
        >
          Update
        </button>
      </div>
    </div>
  );
};

export default FooterBookingDetail;
